import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import { navigate } from "vike/client/router"
import PubSub from "pubsub-js"
import Typography from "aldoo-ra/Typography"

const PricingFooterContact = () => {
  return (
    <CMSRender
      contentType="PageSection"
      match={{ "content.name": "Pricing Footer Contact" }}
      renderItem={(data, id) => (
        <div className="w-full max-w-[450px] lg:max-w-[500px] mx-auto">
          <div className="w-full flex justify-center">
            <div className="w-full flex flex-col md:flex-row items-center justify-center gap-1 md:gap-2 bg-gray_100 rounded-full py-4 px-6">
              <Typography 
                variant="body1"
                className="text-text text-center my-0"
              >
                {data.title}
              </Typography>

              <a
                key={id}
                onClick={() => {
                  if (data?.menu[0]?.options?.action) {
                    PubSub.publish(data.menu[0].options.action)
                    return
                  }
                  if (data.menu[0].link[0].url) {
                    navigate(data.menu[0].link[0].url)
                  }
                }}
                className="text-primary hover:text-primary_hov cursor-pointer underline"
              >
                <Typography variant="btn1">
                  {data.menu[0].label}
                </Typography>
              </a>
            </div>
          </div>
        </div>
      )}
    />
  )
}

export default PricingFooterContact
